export default __webpack_public_path__ + "static/media/phf_new.c51d2828.jpeg";